import type { IFieldPayments } from "./payment.types";



export const ORDER_FORM_PAYMENT: IFieldPayments = {
  column1: [
    {
      id: '1',
      text: 'Parcela 1',
      register: 'payment01',
      fieldInJson: 'condPagto1',
      indexField: 1,
    },
    {
      id: '2',
      text: 'Parcela 2',
      register: 'payment02',
      fieldInJson: 'condPagto2',
      indexField: 3,
    },
    {
      id: '3',
      text: 'Parcela 3',
      register: 'payment03',
      fieldInJson: 'condPagto3',
      indexField: 5,
    },
    {
      id: '4',
      text: 'Parcela 4',
      register: 'payment04',
      fieldInJson: 'condPagto4',
      indexField: 7,
    },
    {
      id: '5',
      text: 'Parcela 5',
      register: 'payment05',
      fieldInJson: 'condPagto5',
      indexField: 9,
    },
    {
      id: '6',
      text: 'Parcela 6',
      register: 'payment06',
      fieldInJson: 'condPagto6',
      indexField: 11,
    },
    {
      id: '7',
      text: 'Parcela 7',
      register: 'payment07',
      fieldInJson: 'condPagto7',
      indexField: 13,
    },
    {
      id: '8',
      text: 'Parcela 8',
      register: 'payment08',
      fieldInJson: 'condPagto8',
      indexField: 15,
    },
    {
      id: '9',
      text: 'Parcela 9',
      register: 'payment09',
      fieldInJson: 'condPagto9',
      indexField: 17,
    },
    {
      id: '10',
      text: 'Parcela 10',
      register: 'payment10',
      fieldInJson: 'condPagto10',
      indexField: 19,
    },
    {
      id: '11',
      text: 'Parcela 11',
      register: 'payment11',
      fieldInJson: 'condPagto11',
      indexField: 21,
    },
    {
      id: '12',
      text: 'Parcela 12',
      register: 'payment12',
      fieldInJson: 'condPagto12',
      indexField: 23,
    },
  ],
  column2: [
    {
      id: '13',
      text: 'Parcela 13',
      register: 'payment13',
      fieldInJson: 'condPagto13',
      indexField: 2,
    },
    {
      id: '14',
      text: 'Parcela 14',
      register: 'payment14',
      fieldInJson: 'condPagto14',
      indexField: 4,
    },
    {
      id: '15',
      text: 'Parcela 15',
      register: 'payment15',
      fieldInJson: 'condPagto15',
      indexField: 6,
    },
    {
      id: '16',
      text: 'Parcela 16',
      register: 'payment16',
      fieldInJson: 'condPagto16',
      indexField: 8,
    },
    {
      id: '17',
      text: 'Parcela 17',
      register: 'payment17',
      fieldInJson: 'condPagto17',
      indexField: 10,
    },
    {
      id: '18',
      text: 'Parcela 18',
      register: 'payment18',
      fieldInJson: 'condPagto18',
      indexField: 12,
    },
    {
      id: '19',
      text: 'Parcela 19',
      register: 'payment19',
      fieldInJson: 'condPagto19',
      indexField: 14,
    },
    {
      id: '20',
      text: 'Parcela 20',
      register: 'payment20',
      fieldInJson: 'condPagto20',
      indexField: 16,
    },
    {
      id: '21',
      text: 'Parcela 21',
      register: 'payment21',
      fieldInJson: 'condPagto21',
      indexField: 18,
    },
    {
      id: '22',
      text: 'Parcela 22',
      register: 'payment22',
      fieldInJson: 'condPagto22',
      indexField: 20,
    },
    {
      id: '23',
      text: 'Parcela 23',
      register: 'payment23',
      fieldInJson: 'condPagto23',
      indexField: 22,
    },
    {
      id: '24',
      text: 'Parcela 24',
      register: 'payment24',
      fieldInJson: 'condPagto24',
      indexField: 24,
    },
  ],
}
